import { Theme } from '@mui/material/styles';
import { ButtonProps } from '@mui/material/Button';

// ----------------------------------------------------------------------

// In MUI v7, LoadingButton was merged into Button with a 'loading' prop.
// The loading indicator classes are now part of Button.
export function loadingButton(_theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ButtonProps }) => ({
          ...(ownerState.variant === 'soft' && {
            '& .MuiButton-loadingIndicator': {
              // Adjust loading indicator position for soft variant
            },
          }),
        }),
      },
    },
  };
}
